import * as React from 'react';
import { useTranslation } from 'react-i18next';

// ─── Types ────────────────────────────────────────────────────────────────────

interface ComingSoonPlaceholderProps {
  feature: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function ComingSoonPlaceholder({ feature }: ComingSoonPlaceholderProps): React.JSX.Element {
  const { t } = useTranslation('settings');

  return (
    <div className="flex h-64 items-center justify-center text-muted-foreground">
      <p>
        {feature} — {t('common.comingSoon')}
      </p>
    </div>
  );
}
